"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { Menu } from '@ark-ui/react';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';
export { MenuContext as Context } from '@ark-ui/react/menu';

const itemBase = [
  "items-center rounded-sm cursor-pointer flex font-medium text-sm leading-5",
  "transition-[background,color] duration-100",
  "[&_:where(svg)]:text-fg-muted",
  "data-[disabled]:text-fg-disabled data-[disabled]:cursor-not-allowed"
];
const menuRecipe = tv({
  slots: withSlotScopeClasses("menu", {
    arrow: "",
    arrowTip: "",
    content: [
      "bg-bg-default rounded shadow-lg flex flex-col outline-none w-[calc(100%+2rem)] z-dropdown",
      "[&[hidden]]:hidden",
      "data-[state=open]:animate-[fadeIn_0.25s_ease-out]",
      "data-[state=closed]:animate-[fadeOut_0.2s_ease-out]"
    ],
    contextTrigger: "",
    indicator: "",
    item: itemBase,
    itemGroup: "flex flex-col",
    itemGroupLabel: "font-semibold text-sm leading-5",
    itemIndicator: "",
    itemText: "",
    positioner: "z-dropdown",
    separator: "",
    trigger: "appearance-none bg-transparent cursor-pointer align-middle font-medium",
    triggerItem: itemBase
  }),
  variants: {
    size: {
      xs: {
        itemGroup: "gap-1",
        itemGroupLabel: "py-1.5 px-1.5 mx-1",
        content: "py-1 gap-1",
        item: "h-8 px-1.5 mx-1 [&_:where(svg)]:w-4 [&_:where(svg)]:h-4",
        triggerItem: "h-8 px-1.5 mx-1 [&_:where(svg)]:w-4 [&_:where(svg)]:h-4"
      },
      sm: {
        itemGroup: "gap-1",
        itemGroupLabel: "py-2 px-2 mx-1",
        content: "py-1 gap-1",
        item: "h-9 px-2 mx-1 [&_:where(svg)]:w-4 [&_:where(svg)]:h-4",
        triggerItem: "h-9 px-2 mx-1.5 [&_:where(svg)]:w-4 [&_:where(svg)]:h-4"
      },
      md: {
        itemGroup: "gap-1",
        itemGroupLabel: "py-2.5 px-2.5 mx-1",
        content: "py-1 gap-1",
        item: "h-10 px-2.5 mx-1 [&_:where(svg)]:w-4 [&_:where(svg)]:h-4",
        triggerItem: "h-10 px-2.5 mx-1.5 [&_:where(svg)]:w-4 [&_:where(svg)]:h-4"
      },
      lg: {
        itemGroup: "gap-1",
        itemGroupLabel: "py-2.5 px-2.5 mx-1",
        content: "py-1 gap-1",
        item: "h-11 px-2.5 mx-1 [&_:where(svg)]:w-5 [&_:where(svg)]:h-5",
        triggerItem: "h-11 px-2.5 mx-1.5 [&_:where(svg)]:w-5 [&_:where(svg)]:h-5"
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const { withRootProvider, withContext } = createSlotRecipeContext(menuRecipe);
withRootProvider(Menu.RootProvider);
const Root = withRootProvider(Menu.Root);
withContext(Menu.Arrow, "arrow");
withContext(Menu.ArrowTip, "arrowTip");
withContext(
  Menu.CheckboxItem,
  "item"
);
const Content = withContext(Menu.Content, "content");
withContext(
  Menu.ContextTrigger,
  "contextTrigger"
);
withContext(
  Menu.Indicator,
  "indicator"
);
const ItemGroupLabel = withContext(
  Menu.ItemGroupLabel,
  "itemGroupLabel"
);
const ItemGroup = withContext(
  Menu.ItemGroup,
  "itemGroup"
);
withContext(
  Menu.ItemIndicator,
  "itemIndicator"
);
const Item = withContext(Menu.Item, "item");
withContext(Menu.ItemText, "itemText");
const Positioner = withContext(
  Menu.Positioner,
  "positioner"
);
withContext(
  Menu.RadioItemGroup,
  "itemGroup"
);
withContext(Menu.RadioItem, "item");
withContext(
  Menu.Separator,
  "separator"
);
withContext(
  Menu.TriggerItem,
  "triggerItem"
);
const Trigger = withContext(
  Menu.Trigger,
  "trigger"
);

export { Content, Item, ItemGroup, ItemGroupLabel, Positioner, Root, Trigger };
